/* eslint-disable camelcase */
import { openWindow } from 'services/inAppBrowser';

export const ARTICLES = {
  accessingAlacarte: 6404134,
};

export const CAROUSELS = {
  onboarding: 25401139,
};

export const showHelpArticle = id => {
  if (window.Intercom) {
    window.Intercom('showArticle', id);
  } else if (window.intercom) {
    window.intercom.displayArticle(id);
  } else {
    openWindow(`https://intercom.help/ckbk/en/articles/${id}`, '_blank');
  }
};

export const showCarousel = id => {
  if (window.intercom) {
    window.intercom.displayCarousel(CAROUSELS[id] || id);
  }
};

export const updateCustomAttributes = custom_attributes => {
  if (window.intercom) {
    window.intercom.updateUser({
      custom_attributes,
    });
  } else if (window.Intercom) {
    window.Intercom('update', { custom_attributes });
  }
};

export default {
  showCarousel,
  showHelpArticle,
  updateCustomAttributes,
};
